import format from 'date-fns/format';

import getBlogImagesResize from '../../../../../helpers/getBlogImagesResize/getBlogImagesResize';
import { DEVICE_SIZES } from '../../../../components/Photo/constants';
import { convertSrcToCorrect } from '../../../../helper/urls';
import { POST_IMAGE_SELECTOR } from '../../../constants';
import getStateValue from '../../../helpers/getStateValue';
import PostImage from '../../Blog/PostImage/PostImage';
import { getPictureSource } from '../../Blog/utils';

import { addGridItemImages } from './utils';

const { BLOG_STATIC_DIR } = require('../../../../../helpers/getBlogImagesResizeUrl/constants');

const preRender = (item, index, elItemsContainer, source) => {
  const { previewImageUrl, images: image } = item || {};

  // for Safari replace(/ /g, 'T')
  const datePublished = format(new Date(item.datePublished.replace(/ /g, 'T')), 'dd MMM yyyy');
  const { layoutSettings } = source || {};
  const { isStaticImagesPublished } = item;
  const apiUrls = getStateValue('apiUrls');
  const staticData = {
    isStaticPublished: isStaticImagesPublished,
    staticDir: `/${BLOG_STATIC_DIR}`,
  };
  const originalSrc = convertSrcToCorrect(previewImageUrl, apiUrls);
  const [imagesResize] = getBlogImagesResize(layoutSettings, [image || {}]);
  const isValidImage = !!imagesResize?.hash;
  const convertedSrc = isValidImage ? convertSrcToCorrect(previewImageUrl, apiUrls, staticData) : originalSrc;

  const { previewTransform: transform, ...rest } = imagesResize || {};
  const previewImage = {
    ...rest,
    transform,
  };

  const preview = {
    url: convertedSrc,
    source: getPictureSource(convertedSrc, previewImage, DEVICE_SIZES, {
      apiUrls,
      staticData,
      originalSrc,
      isValidImage,
    }),
  };

  return {
    ...item,
    datePublished,
    previewImageUrl: convertedSrc,
    preview,
    widthPreview: !!preview.url && !!preview.source,
  };
};

const postRender = (element, data) => {
  addGridItemImages(element, data);

  return element;
};

const didMount = (container) => {
  (new PostImage(POST_IMAGE_SELECTOR)).init(container);
};

export default {
  preRender,
  postRender,
  didMount,
};
